export default __webpack_public_path__ + "static/media/3image.6457e937.png";